const initialState = {
  appBanners: [],
  selectedAppBanner: null,
  loading: false,
  error: null
};

const appBannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "APP_BANNER_LOADING":
      return {
        ...state,
        loading: true,
        error: null // clear old errors on new action
      };

    case "GET_ALL_APP_BANNERS":
      return {
        ...state,
        appBanners: action.data?.data?.bannerData || [],
        loading: false,
        error: null
      };

    case "GET_APP_BANNER_BY_ID":
  return {
    ...state,
    selectedAppBanner: Array.isArray(action.data?.data) ? action.data.data[0] : action.data?.data || null,
    loading: false
  }


    case "APP_BANNER_ERROR":
      return {
        ...state,
        error: action.payload,
        loading: false
      };

    case "CLEAR_APP_BANNER_ERROR":
      return {
        ...state,
        error: null
      };

    case "CLEAR_SELECTED_APP_BANNER":
      return {
        ...state,
        selectedAppBanner: null
      };

    default:
      return state;
  }
};

export default appBannerReducer;